import { Helpers } from '../../helpers';
import { IScheduleWBSs } from '../../interfaces/ischedule-w-b-ss';
import { Schedule } from '../schedule';
import { ScheduleActivity } from '../schedule-activity';
import { ScheduleTemplateName } from '../schedule-template-name';

export class ScheduleWBSsBase {
  ScheduleWBSId: number;
  Name: string | null;
  Code: string | null;
  Level: number | null;
  ParentId: number | null;
  ScheduleTemplateNameId: number | null;
  P6ProjectObjectId: number | null;
  ScheduleId: number | null;
  SequenceNumber: number | null;
  P6ParentScheduleWBSObjectId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SentToP6: Date | null;
  ReceivedByP6: Date | null;
  SysStartTime: Date;
  SysEndTime: Date;
  P6WBSObjectId: number | null;

  ScheduleActivities_ScheduleWBS?: Array<ScheduleActivity> | null;
  Schedule?: Schedule;
  ScheduleTemplateName?: ScheduleTemplateName;

  constructor(item?: IScheduleWBSs) {
    if (item) {

      this.ScheduleWBSId = item.ScheduleWBSId;
      this.Name = item.Name;
      this.Code = item.Code;
      this.Level = item.Level;
      this.ParentId = item.ParentId;
      this.ScheduleTemplateNameId = item.ScheduleTemplateNameId;
      this.P6ProjectObjectId = item.P6ProjectObjectId;
      this.ScheduleId = item.ScheduleId;
      this.SequenceNumber = item.SequenceNumber;
      this.P6ParentScheduleWBSObjectId = item.P6ParentScheduleWBSObjectId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SentToP6 = item.SentToP6 ? new Date(item.SentToP6) : null;
      this.ReceivedByP6 = item.ReceivedByP6 ? new Date(item.ReceivedByP6) : null;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;
      this.P6WBSObjectId = item.P6WBSObjectId;

      this.ScheduleActivities_ScheduleWBS = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_ScheduleWBS);
      this.Schedule = new Schedule(item.Schedule);
      this.ScheduleTemplateName = new ScheduleTemplateName(item.ScheduleTemplateName);
    }
  }
}